import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setAdmin } from "../../redux/adminSlice";
import LoginForm from "../../components/auth/LoginForm";
import LoginHeader from "../../components/auth/LoginHeader";
import LoginBackground from "../../components/auth/LoginBackground";
import { toast } from "react-toastify";
import loginRequest from "../../api/LoginRequest";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
//test
  const handleLogin = async (credentials) => {
    setIsLoading(true);
    try {
      const response = await loginRequest.login(credentials);
      if (response.success) {
        dispatch(
          setAdmin({
            adminData: response.data.data.data,
            token: response.data.data.data.token,
          })
        );
        toast.success(
          response.data.data.reason || "Login successful! Welcome back."
        );
      } else {
        toast.error(
          response.data.data.reason ||
            "Login failed. Please check your credentials."
        );
      }
    } catch (error) {
      toast.error("Login failed. Please check your credentials.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex overflow-hidden relative justify-center items-center min-h-screen bg-gradient-to-br  to-red-800 from-slate-900">
      <LoginBackground />

      <div className="relative z-10 px-6 mx-auto w-full max-w-md">
        <div className="p-8 rounded-2xl border shadow-2xl backdrop-blur-xl bg-white/10 border-white/20">
          <LoginHeader />
          <LoginForm onSubmit={handleLogin} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default Login;
